export interface MenuItem {
    displayName: string;
    target?: string | MenuItem[];
    value?: string;
}

export interface MenuItemEventDetail {
    menuItemData: MenuItem;
}
